import { NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { SearchModule } from 'app/layout/common/search/search.module';
import { DenseLayoutComponent } from 'app/layout/layouts/vertical/dense/dense.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSelectModule } from '@angular/material/select';
@NgModule({
    exports: [
        DenseLayoutComponent
    ], imports: [RouterModule,
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    MatMenuModule,
    SearchModule,
    MatSidenavModule,
    MatSelectModule, DenseLayoutComponent], providers: [provideHttpClient(withXhr(), withInterceptorsFromDi())] })
export class DenseLayoutModule {
}
